import { render, staticRenderFns } from "./MdFile.vue?vue&type=template&id=e1081f1c&"
import script from "./MdFile.vue?vue&type=script&lang=js&"
export * from "./MdFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports